import React, {
  useState,
  useEffect,
  useContext,
  useLayoutEffect,
  useMemo,
} from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import Header from "../../layout/Header/Header";

import { Row, Input, Col } from "reactstrap";
import moment from "moment";
import Swal from "sweetalert2";
import {
  DashPage,
  FilterBar,
  Filtro,
  KpiRow,
  DashCard,
  ChartBox,
  montarGraficas,
  graficaDona,
  graficaBarras,
} from "./dashboardUI";

function DashboardInventarios() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  let anos = new Date();
  anos.setDate(anos.getDate() - 3650);
  const year = anos.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  const [info, setInfo] = useState([]);
  const [graficasUnidadesNegocio, setGraficasUnidadesNegocio] = useState([]);
  const [graficasLineas, setGraficasLineas] = useState([]);
  const [graficasProveedores, setGraficasProveedores] = useState([]);
  const [graficasFamilias, setGraficasFamilias] = useState([]);
  const [graficasAreas, setGraficasAreas] = useState([]);
  const [graficasAnos, setGraficasAnos] = useState([]);
  const [valorInventario, setValorInventario] = useState(0);
  const [cantidadInventario, setCantidadInventario] = useState(0);

  const [selectedAno, setSelectedAno] = useState("");
  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [lineas, setLineas] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [cargando, setCargando] = useState(true);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }

useEffect(()=>{
  axios
  .get(`${URL_DASHBOARDS}Inventarios`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allDisponible = response.data;
    let array = allDisponible
      .map((a) => {
        if (a.disponible > 0) {
          return a;
        }
      })
      .filter(function (el) {
        return el != null;
      });
      setInfo(array)
      
      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });

    axios
    .get(URL_UNIDADES_NEGOCIO, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allUnidadesNegocio = res.data;
      setUnidadesNegocio(allUnidadesNegocio);
    })
    .catch((err) => {
      console.log(err);
    });

    axios
    .get(URL_FAMILIAS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allFamilias = res.data;
      setFamilias(allFamilias);
    })
    .catch((err) => {
      console.log(err);
    });

    axios
    .get(URL_LINEAS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allLineas = res.data;
      setLineas(allLineas);
    })
    .catch((err) => {
      console.log(err);
    });

    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, { 
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allProveedores = res.data;
      setProveedores(allProveedores);
    })
    .catch((err) => {
      console.log(err);
    });

},[])


  useMemo(() => {
      let temp = info
          if (selectedAno) {
            temp = temp.filter((e) =>
              e.ano.includes(selectedAno)
            );
          }
          if (selectedUnidadNegocio) {
            temp = temp.filter((e) =>
              e.idUnidadNegocio.includes(selectedUnidadNegocio)
            );
          }
          if (selectedFamilia) {
            temp = temp.filter((e) =>
              e.idFamilia.includes(selectedFamilia)
            );
          }
          if (selectedLinea) {
            temp = temp.filter((e) =>
              e.idLinea.includes(selectedLinea)
            );
          }

          if (selectedProveedor) {
            temp = temp.filter((e) =>
              e.idProveedor.includes(selectedProveedor)
            );
          }

        let agrupadoUnidadNegocio = temp.reduce(function (groups, item) {
          const val = item["idUnidadNegocio"];
          groups[val] = groups[val] || {
            idUnidadNegocio: item.idUnidadNegocio,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].unidadNegocio = item.unidadNegocio;
          groups[val].idUnidadNegocio = item.idUnidadNegocio;
          return groups;
        }, []);

        let otraUnidadNegocio = Object.values(agrupadoUnidadNegocio).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasUnidadesNegocio(otraUnidadNegocio);

        let agrupadoLinea = temp.reduce(function (groups, item) {
          const val = item["idLinea"];
          groups[val] = groups[val] || {
            idLinea: item.idLinea,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].linea = item.linea;
          groups[val].idLinea = item.idLinea;
          return groups;
        }, []);

        let otraLinea = Object.values(agrupadoLinea).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasLineas(otraLinea);

        let agrupadoFamilia = temp.reduce(function (groups, item) {
          const val = item["idFamilia"];
          groups[val] = groups[val] || {
            idFamilia: item.idFamilia,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].familia = item.familia;
          groups[val].idFamilia = item.idFamilia;
          return groups;
        }, []);

        let otraFamilia = Object.values(agrupadoFamilia).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasFamilias(otraFamilia);

        let agrupadoArea = temp.reduce(function (groups, item) {
          const val = item["idArea"];
          groups[val] = groups[val] || {
            idArea: item.idArea,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].area = item.area;
          groups[val].idArea = item.idArea;
          return groups;
        }, []);

        let otraArea = Object.values(agrupadoArea).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasAreas(otraArea);

        let agrupadoAno = temp.reduce(function (groups, item) {
          const val = item["ano"];
          groups[val] = groups[val] || {
            ano: item.ano,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].ano = item.ano;
          return groups;
        }, []);

        let otraAno = Object.values(agrupadoAno).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasAnos(otraAno);

        let agrupadoProveedor = temp.reduce(function (groups, item) {
          const val = item["idProveedor"];
          groups[val] = groups[val] || {
            idProveedor: item.idProveedor,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].proveedor = item.proveedor;
          groups[val].idProveedor = item.idProveedor;
          return groups;
        }, []);

        let otraProveedor = Object.values(agrupadoProveedor).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasProveedores(otraProveedor);

        let TVal = temp.map((c) => parseFloat(c.valor));
        let TV = TVal.reduce((t, total, index) => t + total, 0);
        setValorInventario(TV);

        let TCan = temp.map((c) => parseFloat(c.disponible));
        let TC = TCan.reduce((t, total, index) => t + total, 0);
        setCantidadInventario(TC);

  }, [info, selectedAno, selectedUnidadNegocio, selectedFamilia, selectedLinea, selectedProveedor]);


  useLayoutEffect(
    () =>
      montarGraficas([
        ["chartdivLineas", (root) => graficaDona(root, { data: graficasLineas, valor: "disponible", categoria: "linea", sufijo: " pzs", centro: "Piezas" })],
        ["chartdivAnos", (root) => graficaDona(root, { data: graficasAnos, valor: "disponible", categoria: "ano", sufijo: " pzs", centro: "Piezas" })],
        ["chartdivProveedores", (root) => graficaDona(root, { data: graficasProveedores, valor: "disponible", categoria: "proveedor", sufijo: " pzs", centro: "Piezas" })],
        ["chartdivAreas", (root) => graficaBarras(root, {
          data: graficasAreas, categoria: "area", series: [{ valor: "disponible", nombre: "Piezas" }],
          sufijo: " pzs", colorPorBarra: true, exportar: true, archivo: "Inventario_Almacenes",
        })],
      ]),
    [graficasLineas, graficasAreas, graficasAnos, graficasProveedores]
  );

  const kpis = [
    { label: "Piezas disponibles", value: cantidadInventario, formato: "numero", icon: "fas fa-boxes", color: "#3b82f6" },
    { label: "Valor del inventario", value: valorInventario, formato: "moneda", icon: "fas fa-dollar-sign", color: "#10b981" },
    { label: "Almacenes", value: graficasAreas.length, formato: "entero", icon: "fas fa-warehouse", color: "#f59e0b" },
    { label: "Líneas", value: graficasLineas.length, formato: "entero", icon: "fas fa-tags", color: "#8b5cf6" },
    { label: "Proveedores", value: graficasProveedores.length, formato: "entero", icon: "fas fa-truck", color: "#0ea5e9" },
  ];

  return (
    <>
      <Header />
      {/* {user.menu_disponible ? ( */}
      <DashPage
        icon="fas fa-tshirt"
        color="#8b5cf6"
        bg="#f5f3ff"
        title="Dashboard Inventarios"
        subtitle="Existencias disponibles por almacén, línea, proveedor y año"
        cargando={cargando}
      >
        <FilterBar>
          <Filtro label="Año" chico>
            <Input
              bsSize="sm"
              type="select"
              value={selectedAno}
              onChange={(e) => {
                setSelectedAno(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {years.map((a) => {
                return <option key={a} value={a}>{a}</option>;
              })}
            </Input>
          </Filtro>

          <Filtro label="Línea">
            <Input
              bsSize="sm"
              type="select"
              value={selectedLinea}
              onChange={(e) => {
                setSelectedLinea(e.target.value);
              }}
            >
              <option value="">Todas</option>
              {lineas
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => {
                  return <option key={a._id} value={a._id}>{a.name}</option>;
                })}
            </Input>
          </Filtro>

          <Filtro label="Proveedor">
            <Input
              bsSize="sm"
              type="select"
              value={selectedProveedor}
              onChange={(e) => {
                setSelectedProveedor(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {proveedores
                .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                .map((a) => {
                  return <option key={a._id} value={a._id}>{a.nombre_comercial}</option>;
                })}
            </Input>
          </Filtro>
        </FilterBar>

        <KpiRow items={kpis} />

        <Row className="dash-row">
          <Col lg={7}>
            <DashCard icon="fas fa-warehouse" color="#f59e0b" title="Existencia por almacén" subtitle="Piezas disponibles">
              <ChartBox id="chartdivAreas" height={320} cargando={cargando} vacio={graficasAreas.length === 0} />
            </DashCard>
          </Col>
          <Col lg={5}>
            <DashCard icon="fas fa-tags" color="#8b5cf6" title="Existencia por línea" subtitle="Piezas y % del total">
              <ChartBox id="chartdivLineas" height={320} cargando={cargando} vacio={graficasLineas.length === 0} />
            </DashCard>
          </Col>
        </Row>

        <Row className="dash-row">
          <Col lg={7}>
            <DashCard icon="fas fa-truck" color="#0ea5e9" title="Existencia por proveedor" subtitle="Piezas y % del total">
              <ChartBox id="chartdivProveedores" height={320} cargando={cargando} vacio={graficasProveedores.length === 0} />
            </DashCard>
          </Col>
          <Col lg={5}>
            <DashCard icon="fas fa-calendar-alt" color="#10b981" title="Existencia por año" subtitle="Piezas y % del total">
              <ChartBox id="chartdivAnos" height={320} cargando={cargando} vacio={graficasAnos.length === 0} />
            </DashCard>
          </Col>
        </Row>
      </DashPage>
      {/* ) : undefined}  */}
    </>
  );
}
export default DashboardInventarios;
